import React from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { usePermissions } from "@/context/PermissionContext";
import { useAuth } from "@/context/AuthContext";

/**
 * Penjaga halaman berbasis izin (centang). Tanpa izin = tidak bisa membuka halaman,
 * termasuk lewat URL langsung. Server tetap menjaga datanya sendiri.
 */
export default function RequirePermission({ permission, bypassRoles = [], children }) {
  const { hasPermission, loading } = usePermissions();
  const { user } = useAuth();
  if (loading) return null;
  if (bypassRoles.includes(String(user?.role || "").toLowerCase())) return children;
  if (hasPermission(permission)) return children;
  toast.error("Akun Anda tidak punya akses ke halaman ini.");
  return <Navigate to="/admin/dashboard" replace />;
}
